export default __webpack_public_path__ + "static/media/react-logo.0d6bd252.svg";